<div
  class="tw:max-w-[360px] tw:rounded-lg tw:bg-gray-7 tw:px-3 tw:py-2 tw:text-sm tw:text-white tw:whitespace-pre-line tw:wrap-anywhere tw:select-text tw:shadow-lg"
>
  {{ text() }}
</div>
